<template>
    <div>
        <!--            <div class="top_tools_div">-->
        <van-sticky :offset-top="offsetTop">
            <div style="background-color: white; box-shadow: 0 2px 3px #cccccc;">

<!--                <TbCategoryTabs ref="TbCategoryTabs" @onSelect="selectCategory"></TbCategoryTabs>-->

                <div id="checkbox_sort_div" :class="checkbox_sort_div">
                    <van-divider
                            :style="{borderColor: '#cccccc', 'margin-top': '0px', 'margin-bottom': '0px'}"></van-divider>

                    <!-- 优惠券 -->
                    <van-checkbox-group v-model="check_result" @change="onCheckBoxChange">
                        <van-row style="margin-left: 15px; margin-top: 10px; margin-bottom: 10px">
                            <van-col span="8">
                                <van-checkbox :name="check_list[0]" shape="round" checked-color="#ff0000">
                                    {{check_list[0]}}
                                </van-checkbox>
                            </van-col>
                            <van-col span="8">
                                <van-checkbox :name="check_list[1]" shape="round" checked-color="#ff0000">
                                    {{check_list[1]}}
                                </van-checkbox>
                            </van-col>
                            <van-col span="8">
                                <van-checkbox :name="check_list[2]" shape="round" checked-color="#ff0000">
                                    {{check_list[2]}}
                                </van-checkbox>
                            </van-col>
                        </van-row>
                    </van-checkbox-group>

                    <van-divider
                            :style="{borderColor: '#cccccc', 'margin-top': '0px', 'margin-bottom': '0px'}"></van-divider>
                    <!-- 排序 -->
<!--                    <TbSortTabs ref="jdSortTabs" @onSelect="onSortSelect"></TbSortTabs>-->
<!--                    <van-row>-->
<!--                        <van-col span="20">-->
<!--                            &lt;!&ndash; 排序 &ndash;&gt;-->
<!--                            <TbSortTabs ref="jdSortTabs" @onSelect="onSortSelect"></TbSortTabs>-->
<!--                        </van-col>-->
<!--                        <van-col span="4">-->
<!--                            <Wp_options_filter_model @getFilterData="getFilterData"></Wp_options_filter_model>-->
<!--                        </van-col>-->
<!--                    </van-row>-->

                </div>
            </div>
        </van-sticky>


        <!--            <div style="position: relative; top: 155px">-->
        <div style="margin-top: 10px;">
<!--            <div style="text-align: center; margin-bottom: 10px">-->
<!--                <van-button type="danger" @click="deleteTaobaoPid">测试授权——清除缓存taobao_pid</van-button>-->
<!--            </div>-->
<!--            <div style="text-align: center; margin-bottom: 10px">-->
<!--                <van-button type="danger" @click="toEleme">饿了么</van-button>-->
<!--            </div>-->

<!--            <div>-->
<!--&lt;!&ndash;                <div style="margin-left: 15px; font-size: 12px; color: red">&ndash;&gt;-->
<!--&lt;!&ndash;                    *预估佣金与实际佣金可能不同，请以订单中的佣金为准<br/>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->

<!--&lt;!&ndash;                <div>&ndash;&gt;-->
<!--&lt;!&ndash;                    <van-button @click="makeAddTaobaoPid">淘宝链接加渠道号(无佣金，针对高佣保级)</van-button>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->

<!--                <Divider dashed-->
<!--                         style="background-color: #EE0A24;padding-left: 10px;padding-right: 10px; margin-top: 10px; margin-bottom: 10px"></Divider>-->
<!--            </div>-->

            <div v-if="!sku_list || sku_list.length === 0">
                <div style="text-align: center; padding-top: 10px">
                    输入关键字，搜索优惠券商品
                </div>
            </div>

            <Wp_pull_list ref="Wp_pull_list" :all-params="allParams"
                     :page-size="pageSize"
                     :use-function="true"
                     :auto-load="autoLoad"
                     @getDatas="getDatas"
                     @onLoad="onLoad"
            >
                <TbSkuInfoCard
                        v-for="(sku_info, index) in sku_list"
                        v-bind:key="index"
                        :skuInfo="sku_info"
                >
                </TbSkuInfoCard>
            </Wp_pull_list>
        </div>
    </div>

    <!--        <van-action-sheet-->
    <!--                title="授权"-->
    <!--                v-model="show_auth"-->
    <!--                @close="sheetClosed"-->
    <!--                style="padding-bottom: 30px; min-height: 70%"-->
    <!--        >-->

    <!--            <div style="margin-bottom: 50px">-->
    <!--                <Alert type="warning" style="margin-left: 10px;margin-right: 10px; font-size: 15px">-->
    <!--                    淘宝相关功能需获得淘宝的授权，请进行以下操作：<br/><br/>-->
    <!--                    1，点击'前往授权'到授权页面；<br/><br/>-->
    <!--                    2，在授权页面，登录您的淘宝账号；<br/>-->
    <!--                    &nbsp;&nbsp;注：若点击登录后页面未刷新，请手动刷新<br/><br/>-->
    <!--                    3，在登录成功后的页面中，点击'授权'，授权成功后会自动跳转回当前淘宝选品页面；<br/><br/>-->
    <!--                </Alert>-->

    <!--            </div>-->
    <!--            <div style="text-align: center; margin-top: 25px;">-->
    <!--                <van-sticky :offset-top="50" style="position: fixed;bottom: 0px;text-align: center; width: 100%; padding-top: 1px;-->
    <!--                                background-color: #ffffff; box-shadow: 1px -1px 5px #999999">-->

    <!--                    <van-row>-->
    <!--                        <van-col span="4">-->
    <!--                            <div @click="show_auth = false">-->
    <!--                                <div style="text-align: center;  margin-top: 5px">-->
    <!--                                    <van-button icon="close" size="mini" style="font-size: 16px; color: #777777; background-color: rgba(0,0,0,0); border: 0px"></van-button>-->
    <!--                                </div>-->
    <!--                                <div style="text-align: center; color: #777777;">关闭</div>-->
    <!--                            </div>-->
    <!--                        </van-col>-->
    <!--                        <van-col span="20">-->
    <!--                            <van-button-->
    <!--                                        type="info"-->
    <!--                                        style="width: 100%; border-radius: 0px"-->
    <!--                                        @click="clickToAuth"-->
    <!--                            >前往授权-->
    <!--                            </van-button>-->
    <!--                        </van-col>-->
    <!--                    </van-row>-->

    <!--                </van-sticky>-->

    <!--            </div>-->
    <!--        </van-action-sheet>-->
</template>

<script>
    import Wp_pull_list from "../../list/Wp_pull_list";
    import TbSkuInfoCard from "../custom/TbSkuInfoCard";
    import TbSortTabs from "../custom/TbSortTabs";
    import {Toast, Dialog} from "vant";
    import TbCategoryTabs from "../custom/TbCategoryTabs";
    import Wp_options_filter_model from "../../custom/Wp_options_filter_model";
    export default {
        name: "Wp_tb_select_simple",
        components: {Wp_options_filter_model, TbCategoryTabs, TbSortTabs, TbSkuInfoCard, Wp_pull_list},
        props:{
            offsetTop: {type: Number, default: 0},
            keywords: {type: String, default: ''},
        },
        data(){
            return{
                //滚动条到顶部的距离的临时存储
                scroll_top_temp: 0,
                //checkbox_sort_div对应的div的class的值
                checkbox_sort_div: "checkbox_sort_div_show",
                //用于判断向下或向上滚动时，只操作一次checkbox_sort_div的值
                scroll_once_temp: true,

                pageSize: 20,
                default_cat: '16,30,50018004,50008090,50006843,50010404,50011699,21,50013864,1801',
                allParams:{
                    adzone_id: '110057800181',
                    q: '',
                    size: 20,
                    page: 1,
                    page_size: 20,
                    page_no: 1,
                    sort: 'des',
                    has_coupon: true,
                    cat: '-1',
                    // is_tmall: false,// 商品筛选-是否天猫商品。true表示属于天猫商品，false或不设置表示不限
                    // need_free_shipment: false,//商品筛选-是否包邮。true表示包邮，false或不设置表示不限
                    end_tk_rate: -1,//Number	false	1234	商品筛选-淘客佣金比率上限。如：1234表示12.34%
                    start_tk_rate: -1,//Number	false	1234	商品筛选-淘客佣金比率下限。如：1234表示12.34%
                    end_price: -1,//Number	false	10	商品筛选-折扣价范围上限。单位：元
                    start_price: -1,//Number	false	10	商品筛选-折扣价范围下限。单位：元


                    // platform: 1,//链接形式：1：PC，2：无线，默认：１
                    // is_overseas:false,//商品筛选-是否海外商品。true表示属于海外商品，false或不设置表示不限
                    // itemloc: '',//商品筛选-所在地
                    // material_id: 2836,//不传时默认物料id=2836；如果直接对消费者投放，可使用官方个性化算法优化的搜索物料id=17004
                    // ip: '',//ip参数影响邮费获取，如果不传或者传入不准确，邮费无法精准提供
                    // need_prepay:false,//商品筛选-是否加入消费者保障。true表示加入，false或不设置表示不限
                    // include_pay_rate_30: false,//	商品筛选(特定媒体支持)-成交转化是否高于行业均值。True表示大于等于，false或不设置表示不限
                    // include_good_rate: false,//商品筛选-好评率是否高于行业均值。True表示大于等于，false或不设置表示不限
                    // include_rfd_rate: false,//商品筛选(特定媒体支持)-退款率是否低于行业均值。True表示大于等于，false或不设置表示不限
                    // npx_level: 1,//商品筛选-牛皮癣程度。取值：1不限，2无，3轻微
                    // end_ka_tk_rate: -1,//商品筛选-KA媒体淘客佣金比率上限。如：1234表示12.34%
                    // start_ka_tk_rate: -1,//商品筛选-KA媒体淘客佣金比率下限。如：1234表示12.34%
                    // device_encrypt: 'MD5',//智能匹配-设备号加密类型：MD5
                    // device_value: '',//智能匹配-设备号加密后的值（MD5加密需32位小写）
                    // device_type: '',//智能匹配-设备号类型：IMEI，或者IDFA，或者UTDID（UTDID不支持MD5加密），或者OAID
                    // lock_rate_end_time: -1,//锁佣结束时间
                    // lock_rate_start_time: -1//	锁佣开始时间

                },
                // allParams: this.$getSelectGoods_AllParams_tb(),
                sku_list: [],

                search_value: '',

                check_list: ['优惠券', '天猫', '包邮'],
                check_result: ['优惠券'],

                //是否展示授权弹窗
                show_auth: false,
                //授权链接
                auth_url: '',
                //是否重新请求一次数据
                re_get_select_goods_tag: true,

                autoLoad: false,
            }
        },

        watch: {
            keywords(newKeywords) {
                this.$log("--------tb------newKeywords--------------")
                this.search_value = newKeywords;
                this.clickToSearch();
            }
        },

        created() {
            // this.initAuthByTaobaoPid();
            // this.initAllParams();

            this.checkAuth();

            this.allParams.cat = this.default_cat;

            if(this.keywords){
                this.search_value = this.keywords;
                this.allParams.q = this.search_value;
                this.autoLoad = true;
            }

            //num_iids=606856641695&md5=4b3bd5c3983e435242ff724c2339aa62&rnum=1
            // this.$log("md5 --- " + this.$md5('1584322386173' + 'Waps_jd_MD5key'))
        },
        mounted() {
            document.documentElement.scrollTop = document.body.scrollTop = 0;

            window.addEventListener('scroll', this.scrollListener, true);
        },
        destroyed() {
            window.removeEventListener('scroll', this.scrollListener);
        },

        methods:{
            // toEleme(){
            //     let params = {
            //         relation_id: this.$store.state.taobao_pid
            //     };
            //     this.$getElemeData(params, response=>{
            //         if(response && response.code === 200){
            //             let _click_url = response.data.click_url;
            //             let _short_click_url = response.data.short_click_url;
            //             let _wx_miniprogram_path = response.data.wx_miniprogram_path;
            //             let _wx_qrcode_url = response.data.wx_qrcode_url;
            //
            //             window.location.href = _click_url;
            //         }
            //     })
            // },

            /**
             * 使用指定的taobao_pid
             */
            initAuthByTaobaoPid(){
                let _tb_pid = this.$common.getUrlKey('tb_pid');
                let user = this.$store.state;
                user.taobao_pid = _tb_pid;
                this.$store.commit('login', user);
            },

            // makeAddTaobaoPid(){
            //     // this.makeCommand('https://item.taobao.com/item.htm?id=584798854662')
            //     // this.makeCommand('https://s.click.taobao.com/item.htm?id=584798854662')
            //     this.getSkuDetail('605160000819')
            // },

            makeCommand(_url) {
                let loadingToast = Toast.loading({
                    message: '口令生成中...',
                    forbidClick: true,
                    duration: 0,
                });
                if(_url){
                    let click_url = _url + '&relationId=' + this.$common_tb.getTaobaoPid();

                    this.$log("click_url = " + click_url)
                    let params = {
                        url: encodeURIComponent(encodeURIComponent(click_url)),
                        text: '您的优惠口令是'
                        // url: encodeURI('https:' + this.skuInfo.url)
                    };
                    this.$getTbCommand_tb(params, response=>{
                        this.$log(response)
                        if(response && response.code === 200){

                            loadingToast.clear();
                        }
                    });
                }

            },

            getFilterData(filterData){

                this.initStatus();

                this.allParams.start_price = filterData.price_min;
                this.allParams.end_price = filterData.price_max;
                this.allParams.start_tk_rate = filterData.commission_share_min * 100;
                this.allParams.end_tk_rate = filterData.commission_share_max * 100;

                this.$refs.Wp_pull_list.onLoad();
            },

            selectCategory(categoryData) {
                this.$log(categoryData)
                this.initStatus();

                // if(categoryData.cat_id === -1){
                //     this.allParams.optid = this.optid_for_top;
                // }else{
                //     this.allParams.optid = -1;
                // }
                if(categoryData && categoryData.cat_id)
                this.$log("this.allParams.optid = " +this.allParams.optid)
                this.allParams.cat = categoryData.cat_id;

                this.allParams.q = '';
                this.search_value = '';

                this.$emit('clearSearch');

                this.$refs.Wp_pull_list.onLoad();
            },


            /**
             * 删除缓存中的taobao_pid（测试使用）
             */
            deleteTaobaoPid(){
                let user = this.$store.state;
                user.taobao_pid = '';
                this.$store.commit('login', user);
                window.location.reload();
            },

            /**
             * 检查淘宝授权
             */
            checkAuth(){

                //授权成功后重新跳转回当前页面时，会带参数taobao_pid
                let tb_pid = this.$common.getUrlKey('taobao_pid');
                let type = this.$common.getUrlKey('type');
                this.$log("href = " + window.location.href)
                this.$log("tb_pid = " + tb_pid)
                this.$log("type = " + type)

                if(type){
                    if(type === '0'){
                        if(tb_pid){
                            let user = this.$store.state;
                            user.taobao_pid = tb_pid;
                            // user.userPhone = "";
                            this.$store.commit('login', user);

                            let url = window.location.href;
                            if(url.indexOf("?") !== -1){
                                url = url.substring(0, url.indexOf("?"));
                            }
                            //替换地址，将taobao_pid等参数去掉
                            window.location.replace(url);
                            Toast.success({
                                message:'授权成功'
                            })
                        }
                    }else if(type === '1'){
                        //授权使用的淘宝账号重复
                        let oldmark = this.$common.getUrlKey('oldmark');
                        let _message = '您授权所使用的淘宝账号已进行过授权，';
                        if(oldmark){
                            _message = _message + '授权会员编号：' + oldmark + '。\n请使用其他淘宝账号重新授权。';
                        }else{
                            _message = _message + '请使用其他淘宝账号重新授权。';
                        }

                        Dialog.alert({
                            title: '提示',
                            message: _message,
                            messageAlign: 'left'
                        }).then(()=>{
                            this.showAuthDialog();
                        })
                    }
                }else{
                    this.showAuthDialog();
                }



            },

            showAuthDialog(){
                setTimeout(()=>{
                    // let taobao_pid = this.$store.state.taobao_pid;
                    let taobao_pid = this.$common_tb.getTaobaoPid();
                    if(!taobao_pid){
                        Dialog.config({
                            title: '提示',
                            message: '未查询到淘宝授权，该功能暂不可使用'
                        });
                    }
                    // if(!taobao_pid){
                    //     // this.show_auth = true;
                    //     Dialog.confirm({
                    //         title: "提示",
                    //         message:"淘宝相关功能需获得淘宝的授权，请进行以下操作：\n\n" +
                    //             "1，点击'前往授权'到授权页面；\n\n" +
                    //             "2，在授权页面，登录您的淘宝账号；\n" +
                    //             "  注：若点击登录后页面未刷新，请手动刷新\n\n" +
                    //             "3，在登录成功后的页面中，点击'授权'，授权成功后会自动跳转回当前淘宝选品页面；",
                    //         confirmButtonText: '前往授权',
                    //         messageAlign: 'left',
                    //
                    //     }).then(()=>{
                    //         this.clickToAuth();
                    //     }).catch(()=>{
                    //         this.$router.push('select')
                    //     })
                    // }
                }, 500)
            },

            clickToAuth(){
                // let jump_url = window.location.href;
                //http://localhost:8080/#/select_tb
                //http://localhost:8080/#/select_tb?_t=1584927750000

                this.auth_url = this.$common_tb.get_oauth_url + '&state=' + this.$store.state.username;// + '&jump_url=' + jump_url;
                this.$log("this.auth_url = " + this.auth_url)
                window.location.href = this.auth_url;
            },

            sheetClosed(){
                this.$router.push('select')
            },

            onCopySuccess(){
                Toast.success({
                    message: '复制成功'
                });
            },

            onError() {
                Toast.fail({
                    message: '复制失败'
                });
            },

            /**
             * 下拉刷新
             */
            onRefresh() {
                this.initStatus();

                this.$refs.Wp_pull_list.onLoad();
            },

            /**
             * 排序选项被选中
             */
            onSortSelect(label, sort) {
                this.initStatus();
                this.$log("label = " + label)
                if(label){
                    if(sort === 'desc'){
                        if(label){
                            this.allParams.sort = label + '_des';
                        }
                    }else{
                        this.allParams.sort = label + '_asc';
                    }
                }else{
                    this.allParams.sort = '';
                }

                this.$refs.Wp_pull_list.onLoad();
            },

            /**
             * 复选框筛选条件改变的回调
             */
            onCheckBoxChange(check_values) {
                this.initStatus();

                //优惠券
                if (check_values.includes(this.check_list[0])) {
                    this.allParams.has_coupon = true;
                } else {
                    this.allParams.has_coupon = false;
                }
                //天猫
                if (check_values.includes(this.check_list[1])) {
                    this.allParams.is_tmall = true;
                } else {
                    this.allParams.is_tmall = false;
                }
                //包邮
                if (check_values.includes(this.check_list[2])) {
                    this.allParams.need_free_shipment = true;
                } else {
                    this.allParams.need_free_shipment = false;
                }

                this.$refs.Wp_pull_list.onLoad();
            },


            /**
             * 根据条件查询数据
             */
            clickToSearch() {
                this.initStatus();

                this.allParams.q = this.search_value;

                if(!this.search_value){
                    this.allParams.cat = this.default_cat;
                }else{
                    this.allParams.cat = '';
                }
                this.$log("this.search_value = " + this.search_value)

                this.$refs.Wp_pull_list.clickToLoad();
            },

            searchInputClick(id){
                this.selectCategrayTab(id);
            },

            selectCategrayTab(id){
                if(this.$refs.TbCategoryTabs){
                    this.$refs.TbCategoryTabs.active_model = id;
                    this.$refs.TbCategoryTabs.onSelect(id);
                }
            },

            getSearchValue(value){
                this.search_value = value;
            },

            initStatus(){
                this.$refs.Wp_pull_list.initStatus();
                this.sku_list = [];

                document.documentElement.scrollTop = document.body.scrollTop = 0;
            },


            initAllParams(){
                if(this.allParams){
                    //默认选中优惠券
                    if (this.check_result.includes(this.check_list[0])) {
                        this.allParams.has_coupon = true;
                    }else {
                        this.allParams.has_coupon = false;
                    }
                }
            },


            onLoad(data_list){
                this.sku_list = data_list;

                this.$emit('onLoad')
            },

            // getSelectGoods(){
            //     let params = {
            //         adzone_id: '109818400003',
            //         q: '',
            //         size: 20,
            //         page: 1,
            //         sort: 'desc',
            //     };
            //
            //     this.getDatas(params, data=>{
            //         this.sku_list = data;
            //     })
            //
            // },

            getDatas(params, fn){
                if(this.$common_tb.getTaobaoPid){
                    let keyword = params.q;
                    //如果搜索关键字为全数字，并长度大于8，则直接使用通过商品id搜索商品详情的接口
                    if(keyword && this.$common.isNumber(keyword) && keyword.length >8){
                        this.getSkuDetail(keyword, fn);
                    }else{
                        // this.getSelectGoodsList(params, fn);
                        this.getSelectGoodsListWithJson(params, fn);
                    }
                }
            },

            /**
             * 通过商品id搜索商品详情
             */
            getSkuDetail(goods_id, fn){
                let params = {
                    num_iids: goods_id
                };
                this.$getSkuDetailData_tb(params, response=>{
                    this.$log(response)
                    if(response && response.code === 200){
                        if(response.data){
                            if(fn){
                                fn([response.data])
                            }
                        }
                    }
                })
            },

            /**
             * 获取商品列表(请求参数为json)
             */
            getSelectGoodsListWithJson(params, fn){
                params.page_no = params.page;
                this.$getSelectGoodsJson_tb(params, response=>{
                    this.$log(response)
                    if(response){
                        if(response.code === 200){
                            if(response.data){
                                //若获取数据成功，重置重新请求标识为true
                                this.re_get_select_goods_tag = true;
                                if(fn){
                                    fn(response.data)
                                }
                            }else{
                                if (fn) {
                                    fn(null);
                                }
                                Toast.fail({
                                    message: '请求超时，请下拉刷新' + response.code
                                })
                            }
                        }else if(response.code === 15){
                            // {"msg":"无结果","code":15,"data":"[]"}
                            if(this.re_get_select_goods_tag){
                                this.re_get_select_goods_tag = false;
                                this.getSelectGoodsListWithJson(params, fn);
                            }else{
                                if (fn) {
                                    fn(null);
                                }
                            }
                        }else{
                            if (fn) {
                                fn(null);
                            }
                        }

                    }else{
                        if (fn) {
                            fn(null);
                        }
                    }
                })
            },

            /**
             * 获取商品列表
             */
            getSelectGoodsList(params, fn){
                this.$getSelectGoods_tb(params, response=>{
                    this.$log(response)
                    if(response){
                        if(response.code === 200){
                            if(response.data){
                                //若获取数据成功，重置重新请求标识为true
                                this.re_get_select_goods_tag = true;
                                if(fn){
                                    fn(response.data)
                                }
                            }else{
                                if (fn) {
                                    fn(null);
                                }
                                Toast.fail({
                                    message: '请求超时，请下拉刷新' + response.code
                                })
                            }
                        }else if(response.code === 15){
                            // {"msg":"无结果","code":15,"data":"[]"}
                            if(this.re_get_select_goods_tag){
                                this.re_get_select_goods_tag = false;
                                this.getSelectGoodsList(params, fn);
                            }else{
                                if (fn) {
                                    fn(null);
                                }
                            }
                        }else{
                            if (fn) {
                                fn(null);
                            }
                        }

                    }else{
                        if (fn) {
                            fn(null);
                        }
                    }
                })
            },

            /**
             * 选品界面中的滚动条的监听
             */
            scrollListener() {
                //滚动条距离顶部距离
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                // this.$log("window.pageYOffset = " + window.pageYOffset)
                // this.$log("document.documentElement.scrollTop = " + document.documentElement.scrollTop)
                // this.$log("document.body.scrollTop = " + document.body.scrollTop)

                if (this.scroll_top_temp <= scrollTop && scrollTop > 80) {
                    //向下滚动时隐藏筛选和排序
                    // checkbox_sort_div.style.display = 'none';

                    if (this.scroll_once_temp) {
                        this.checkbox_sort_div = "checkbox_sort_div_hide";
                        this.scroll_once_temp = false;
                    }

                } else {
                    //向上滚动时显示筛选和排序
                    // checkbox_sort_div.style.display = 'block';

                    if (!this.scroll_once_temp) {
                        this.checkbox_sort_div = "checkbox_sort_div_show";
                        this.scroll_once_temp = true;
                    }
                }

                this.scroll_top_temp = scrollTop;

            },
        }
    }
</script>

<style scoped>
    .top_tools_div{
        width: 100%;
        min-height: 80px;
        position: fixed;
        top: 0px;
        z-index: 1999;
        /*box-shadow: 0px 1px 5px #999*/
    }

    .checkbox_sort_div_hide {
        max-height: 0px;
        -webkit-transition: max-height 0.5s;
        transition: max-height 0.5s;
        overflow: hidden;
    }

    .checkbox_sort_div_show {
        overflow: hidden;
        -webkit-transition: max-height 0.5s;
        transition: max-height 0.5s;
        max-height: 100px;
    }
</style>